import { Link, Navigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api.js'
import { useAuth } from '../contexts/AuthContext.jsx'
import GlyphTile from '../components/GlyphTile.jsx'
import Icon from '../components/Icon.jsx'
import { lucideGlyph } from '../components/LucideIcon.jsx'
import { listPath } from '../lib/lists.js'

/**
 * /lists — where the nav item lands. One tile per list, in the owner's order, each opening
 * its board. A company with a single list is sent straight to it: a page offering one
 * choice is a click for nothing.
 */
export default function ListsIndex() {
  const { can } = useAuth()
  const { data } = useQuery({ queryKey: ['lists'], queryFn: () => api.get('/api/lists') })

  if (!data) return <div className="page empty">Loading…</div>
  const lists = data.lists
  if (lists.length === 1) return <Navigate to={listPath(lists[0])} replace />

  return (
    <div className="page">
      <div className="page-head">
        <h1>Lists</h1>
      </div>

      {lists.length === 0 ? (
        <div className="card empty">
          No lists yet.{' '}
          {can.manageLists ? (
            <>Set one up under <Link to="/settings/lists">Settings → Lists</Link>.</>
          ) : (
            'An owner can set one up under Settings.'
          )}
        </div>
      ) : (
        <div className="integration-tiles list-tiles">
          {lists.map((l) => (
            <Link key={l.id} to={listPath(l)} className="integration-tile list-tile">
              <GlyphTile icon={lucideGlyph(l.icon)} tint={l.color} size={40} />
              <span className="integration-text">
                <span className="integration-name">{l.name}</span>
                {l.description && <span className="integration-blurb">{l.description}</span>}
              </span>
              <Icon name="right" size={18} className="integration-go" />
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
